/* eslint-disable @nx/workspace/a11y/require-keyboard-handlers */
'use client';
import { Card } from '@osmosis/tailwind-ui/components/Card';
import React, { ReactNode, useEffect, useState, useRef } from 'react';

import LockoutBlock from './LockoutBlock';
import { track } from '../../../lib/util/tracking';
import { useLearnAccess } from '../../../context/LearnAccessContext';

type Props = {
  isLockoutBlock?: boolean;
  resource?: string;
  modalKey?: 'flashcards' | 'questions';
  children: ReactNode;
  classNames?: string;
};

/**
 * .
 */
export default function LearnBlockClient({
  isLockoutBlock,
  resource,
  modalKey,
  children,
  classNames = '',
}: Props): JSX.Element {
  const [showLockout, setShowLockout] = useState(false);

  const { hasAccess, handleFlashcardAccess, handleQuestionsAccess } =
    useLearnAccess();

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleEnter = () => {
    setShowLockout(true);
  };

  useEffect(() => {
    if (!hasAccess && isLockoutBlock && resource && showLockout) {
      track(
        'show_learn_page_lockout',
        {
          type: resource,
        },
        ['keen'],
      );
    }
  }, [resource, hasAccess, isLockoutBlock, showLockout]);

  const handleLeave = () => {
    setShowLockout(false);
  };

  useEffect(
    () => () => {
      timerRef.current && clearTimeout(timerRef.current);
    },
    [],
  );

  const handleTouchEnd = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => handleLeave(), 5000);
  };

  return (
    <Card
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      onTouchStart={handleEnter}
      onTouchEnd={handleTouchEnd}
      onClick={() => {
        if (!modalKey) return;

        ({
          flashcards: handleFlashcardAccess,
          questions: handleQuestionsAccess,
        })[modalKey]();
      }}
      data-testid="learn-block-wrapper"
      className={`relative ${classNames}`}
    >
      {isLockoutBlock && <LockoutBlock isVisible={showLockout} />}
      {children}
    </Card>
  );
}
